var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',[_c('v-icon',{attrs:{"color":_vm.$vuetify.theme.dark ? '#647E98' : '#171717'}},[_vm._v(" mdi-view-dashboard ")]),(_vm.isDashboard)?_c('span',[_vm._v("Hello! "+_vm._s(`${_vm.loggedAdmin?.fname || ''} ${_vm.loggedAdmin?.lname || ''}`))]):_c('span',[_vm._v(_vm._s(_vm.currentPageTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }